import { createSlice } from "@reduxjs/toolkit";

const appActivitySlice = createSlice({
    name: "appActivityBoard",
    initialState: {
        appActivityData: null,
        activityDetailData:null

    },
    reducers: {
        setAppActivityData: (state, action) => {
            state.appActivityData = action?.payload
        },
        setActivityDetailData:(state,action) => {
            state.activityDetailData = action?.payload
        },
        removeAppActivityData: (state, action) => {
            switch (action?.payload) {
                case 'REMOVE_APP_ACTIVITY_DATA':
                    state.appActivityData = null
                    break;

                default: {
                    state.appActivityData = null
                }
            }
        },
        removeActivityDetailData: (state,action) => {
            switch (action?.payload) {
             case 'REMOVE_ACTIVITY_DETAIL_DATA' :
                 state.activityDetailData = null
                 break;
              default: {
                 state.activityDetailData = null
              }   
            }
         },
         clearAppActivity: (state, action) => {
            state.appActivityData = null
            state.activityDetailData = null
         }
    }
});

// this is for dispatch
export const { setAppActivityData, removeAppActivityData ,setActivityDetailData,removeActivityDetailData, clearAppActivity} = appActivitySlice.actions;

// this is for configureStore
export default appActivitySlice.reducer;
